module.exports = {
  NEW_REQUISITION: 'NEW_REQUISITION'
}
